import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Field from "../../../../../../components/shared/Form/Field";
import Select from "../../../../../../components/shared/inputs/Select";
import OptionsTable from "../../../components/OptionsTable";
import Shift from "./Shift";
import { useGroups } from "../../../../General/OrganisationLevelGroups/context";

const pageSizes: number[] = [10, 20, 30, 40, 50, 100];
const caseOptions = ["normal", "uppercase", "lowercase", "capitalize"] as const;

function Settings() {
    const { t } = useTranslation();
    const { allocatedGroups } = useGroups();

    const columns = useMemo(() => [
        { label: t("summary"), name: "hideSummary" },
        { label: t("user-profile"), name: "hideUserProfile" },
        { label: t("daily-info"), name: "hideDailyInfo" },
        { label: t("print"), name: "hidePrint" },
    ], [t]);

    const shiftDisplayFields = useMemo(() => [
        { label: t("job"), name: "shiftDisplay.job" },
        { label: t("pay-code"), name: "shiftDisplay.payCode" },
        ...(allocatedGroups ?? []).map((group: any) => ({
            label: group.description,
            name: `shiftDisplay.${group.level.replaceAll("_", "")}`,
        })),
    ], [t, allocatedGroups]);

    return (
        <div className="tw-flex tw-flex-col tw-gap-6">
            <Field name="defaultPageSize" label={t("default-page-size")} className="tw-mb-0" shouldUnregister={false}>
                <Select>
                    {pageSizes.map((page) => (
                        <Select.Item key={page} value={String(page)}>{page}</Select.Item>
                    ))}
                </Select>
            </Field>

            <Field name="shiftCaseDisplay" label={t("shift-case-display")} className="tw-mb-0" shouldUnregister={false}>
                <Select>
                    {caseOptions.map((option) => (
                        <Select.Item key={option} value={option}>{t(option)}</Select.Item>
                    ))}
                </Select>
            </Field>

            <Shift />

            <div className="tw-flex tw-flex-col tw-gap-2">
                <span className="tw-text-sm tw-font-medium tw-text-foreground">{t("shift-display-data")}</span>
                <OptionsTable fields={shiftDisplayFields} header={t("display")} />
            </div>

            <OptionsTable fields={columns} />
        </div>
    );
}

export default Settings;
